import { userActions } from "./user-slice";
import { uiActions } from "../ui-slice";

export const GetUsers = (email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Cargando información",
        message: "Se esta solicitando la información al servidor.",
      })
    );
    const GetUsersInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/getall`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();      
      return data;
    };

    try {
      const response = await GetUsersInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setUsers({
            users: response.data.map((user) => {
              return {
                ...user,
                status: user.status === true ? "Activo" : "Inactivo",
              };
            }),
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userActions.setUsers({
            statues: [],
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la información solicitada",
        })
      );
    }
  };
};

export const GetUserInfo = (id, email) => {
  return async (dispatch) => {
    const getUserInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la persona");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getUserInfo();

      // setRepresentativeName(response.data);
      return response.data;
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la persona",
        })
      );
    }
  };
};

export const GetUser = (id, email, showNotification) => {
  return async (dispatch) => {
    if (showNotification !== undefined && showNotification === true) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Solicitando persona",
          message: "Solicitando persona al servidor.",
        })
      );
    }
    const getUserInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la persona");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getUserInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setUser({
            user: response.data,
          })
        );
        if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userActions.setUser({
            user: {},
          })
        );
        if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la persona",
        })
      );
    }
  };
};
export const UpdateUser = (user, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando persona",
        message: "Solicitando Actualización dla persona al servidor.",
      })
    );
    const updateUserInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/update`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: user.id,
            Name: user.name,
            LastName: user.lastName,
            Identification: user.identification,
            CellPhone: user.cellPhone,
            CountryId: user.countryId,
            City: user.city,
            Address: user.address,
            Company: user.company,
            Status: user.status,
            Token: user.token,
            FullName: user.fullName,
            Ordens: user.ordens,
            DocumentTypeId: user.documenttypeId,
            ChargeId: user.chargeId,
            DepartmentId: user.departmentId,
            OrganizationId: user.organizationId,
            Surname1: user.surname1,
            Surname2: user.surname2,
            Email: user.email,
            Profile: user.profile,
            Password: user.password,
            TemporalPassword: user.temporalpassword,
            UseLimit: user.useLimit,
            LegalDocument: user.legalDocument,
            autentikarId: user.autentikarId,
            UanatacaId: user.uanatacaId,
            onboardingStatus: user.onboardingStatus,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar la persona");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updateUserInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setUser({
            user: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "persona actualizada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userActions.setUser({
            user: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar la persona",
        })
      );
    }
  };
};
export const CreateUser = (user, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando persona",
        message: "Solicitando Creación de la persona al servidor.",
      })
    );

    const createUserInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/create`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Name: user.name,
            Identification: user.identification,
            CellPhone: user.cellPhone,
            Countryid: user.countryid,
            City: user.city,
            Address: user.address,
            Documenttypeid: user.documenttypeid,
            Chargeid: user.chargeid,
            Departmentid: user.departmentid,
            Organizationid: user.organizationid,
            Surname1: user.surname1,
            Surname2: user.surname2,
            Email: user.email,
            Password: user.password,
            Profile: user.profile,
            IsIntern: true,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear la persona");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createUserInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setUser({
            user: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "persona Creado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        // dispatch(
        //   userActions.setUser({
        //     user: {},
        //   })
        // );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear la persona",
        })
      );
    }
  };
};

export const CreateExternalUser = (user, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando persona",
        message: "Solicitando Creación de la persona al servidor.",
      })
    );

    const createUserInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/create`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Name: user.name,
            Identification: user.identification,
            CellPhone: user.cellPhone,
            Countryid: user.countryid,
            City: user.city,
            Address: user.address,
            Documenttypeid: user.documenttypeid,
            Chargeid: user.chargeid,
            Departmentid: user.departmentid,
            Organizationid: user.organizationid,
            Surname1: user.surname1,
            Surname2: user.surname2,
            Email: user.email,
            Password: user.password,
            Profile: user.profile,
            IsIntern: false,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear la persona");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createUserInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setUser({
            user: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "persona Creado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        // dispatch(
        //   userActions.setUser({
        //     user: {},
        //   })
        // );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear la persona",
        })
      );
    }
  };
};
export const ActiveUser = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Activando persona",
        message: "Solicitando activación de la persona al servidor.",
      })
    );
    const activeUserInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/active`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo activar la persona");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await activeUserInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setUser({
            user: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "persona Activada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userActions.setUser({
            user: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo activar la persona",
        })
      );
    }
  };
};
export const InactiveUser = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Inactivando persona",
        message: "Solicitando activación de la persona al servidor.",
      })
    );
    const inactiveUserInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/inactive`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo inactivar la persona");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await inactiveUserInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setUser({
            user: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "persona Inactivada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userActions.setUser({
            user: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo inactivar la persona",
        })
      );
    }
  };
};


export const UploadUsers = (file, email) => {

  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Enviando los archivos",
        message: "Solicitando Creación de los usuarios al servidor.",
      })
    );
    
    let formData = new FormData();
    
    formData.append("File", file.files[0]);    
    
    formData.append("UserName", email);
    
    const createUserUpload = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/createByFile`,
        {
          method: "POST",
          headers: {
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
          body: formData,
        }
      );
      if (!response.ok) {
        console.log(response);
        
        throw new Error("No se pudo crear la firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createUserUpload();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Usuarios Cargados exitosamente",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
       
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo enviar el archivo",
        })
      );
    }
  };
};
